<template v-bind="$props">
  <div>
    <v-toolbar dark color="primary" enlevation="2">
      <v-icon class="mr-3" @click="$router.go(-1)">mdi-arrow-left</v-icon>
      <v-toolbar-title v-if="instituteName">
        {{ instituteName }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn dark text class="text-body-2" @click="openCreateClassroom()">
        New ClassRoom
      </v-btn>
    </v-toolbar>
    <AssignModeratorDailog
      :enrollModeratorDialog="enrollModeratorDialog"
      @assign-moderator="onAssignModerator"
      @close-dialog="enrollModeratorDialog = false"
    />
    <v-container fluid>
      <ContextMenu :contextMenu="contextMenuObject"></ContextMenu>
      <CustomDataTable
        :headers="classRoomHeaders"
        :items="classRooms"
        :hide-default-footer="classRooms.length < 10"
        item-key="classRoomId"
        item-value="classRoomId"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
          <v-icon v-if="item.oneToOne == true" class="mr-2" color="primary">
            mdi-account-switch-outline
          </v-icon>
        </template>
        <template v-slot:[`item.startDate`]="{ item }">
          {{ formatDateTime(item.startDate) }}
        </template>
        <template v-slot:[`item.teacherName`]="{ item }">
          {{
            item?.teacherInfo?.teacherName
              ? item?.teacherInfo?.teacherName
              : "--"
          }}
        </template>
        <template v-slot:[`item.moderatorName`]="{ item }">
          {{
            item?.moderatorInfo?.moderatorName
              ? item?.moderatorInfo?.moderatorName
              : "--"
          }}
        </template>
        <template v-slot:[`item.courseId`]="{ item }">
          <router-link
            style="text-decoration: none"
            class="text-h6"
            to="/home/courses"
            >{{ getCourseNameById(item.courseId) }}</router-link
          >
        </template>
        <template v-slot:[`item.model`]="{ item }">
          <v-chip small :color="getModelColor(item.model)">{{
            item.model ? item.model : "--"
          }}</v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-row>
            <v-col class="pa-0 ma-0">
              <v-chip
                small
                :color="
                  item.status == 'SCHEDULED' ? 'success-chip' : 'secondary-chip'
                "
              >
                {{ item.status }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0 ma-0">
              <v-chip
                x-small
                :color="
                  item.status == 'SCHEDULED' ? 'error-chip' : 'orange-chip'
                "
              >
                {{ "C : " + item.classes
                }}{{
                  item.extraClasses != 0 && item.extraClasses != null
                    ? " + " + item.extraClasses
                    : ""
                }}
              </v-chip>
              <v-chip
                class="mx-1"
                x-small
                :color="
                  item.status == 'SCHEDULED' ? 'error-chip' : 'orange-chip'
                "
              >
                {{ "S : " + item.students.length }}
              </v-chip>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <!-- <v-list-item
                :key="1"
                @click="openAddClassRoomDialog(item)"
              >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="success"  class="mr-2">mdi-eye</v-icon>
                    </template>
                    <span>Classroom Details</span>
                  </v-tooltip>
                <v-list-item-title>{{ "Classroom Details" }}</v-list-item-title>
              </v-list-item> -->
              <v-list-item :key="1" @click="openEnrollDialog(item, 'Student')">
                <v-icon class="mr-2" color="primary">
                  mdi-account-multiple-plus-outline
                </v-icon>
                <v-list-item-title>{{ " Enroll Student" }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :key="2"
                v-if="item.status == 'SCHEDULED'"
                @click="viewSchedule(item)"
              >
                <v-icon class="mr-2" color="success"> mdi-eye </v-icon>
                <v-list-item-title>{{ "View Schedule" }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.model != 'SELF_LEARNING'"
                :key="3"
                @click="openEnrollDialog(item, 'Teacher')"
              >
                <v-icon class="mr-2" color="secondary">
                  mdi-account-plus-outline
                </v-icon>
                <v-list-item-title>{{ " Change Teacher" }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="
                  !item.oneToOne &&
                  !item.moderatorInfo &&
                  item.model != 'SELF_LEARNING'
                "
                :key="4"
                @click="openModeratorEnrollDialog(item)"
              >
                <v-icon class="mr-2" color="orange">
                  mdi-account-plus-outline
                </v-icon>
                <v-list-item-title>{{ " Assign Moderator" }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="
                  !item.oneToOne &&
                  item.moderatorInfo &&
                  item.model != 'SELF_LEARNING'
                "
                :key="4"
                @click="unassignModerator(item)"
              >
                <v-icon class="mr-2" color="error">
                  mdi-account-minus-outline
                </v-icon>
                <v-list-item-title>{{
                  " Unassign Moderator"
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :key="5"
                v-if="item.status == 'SCHEDULED'"
                @click="openExtraClassDialog(item)"
              >
                <v-icon class="mr-2" color="warning">
                  mdi-google-classroom
                </v-icon>
                <v-list-item-title>{{ "Extra Class" }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </CustomDataTable>
    </v-container>

    <StudentEnrollmentDialog
      ref="studentEnrollmentDialog"
      @student-enrollment-updated="updateClassRoomData"
    />
    <TeacherEnrollmentDialog
      ref="teacherEnrollmentDialog"
      :addClassRoomDialog="addClassRoomDialog"
      @teacher-enrolled="updateClassRoomData"
      @teacher-selected="onTeacherSelected"
    />
    <ExtraClassCreateDailog
      ref="extraClassDialog"
      @extra-class-created="getAllClassRoomByInstituteId"
    />
  </div>
</template>

<script>
import {
  BASE_URL,
  CLASSROOM_ASSIGN_TEACHER,
  CLASSROOM_ASSIGN_MODERATOR,
  CLASSROOM_CREATE_SCHEDULE,
  CLASSROOM_UN_ASSIGN_TEACHER,
  CLASSROOM_UN_ASSIGN_MODERATOR,
  CREATE_CLASSROOM,
  GET_ALL_CLASSROOMS,
  GET_ALL_COURSES,
  GET_ALL_INSTITUTES,
  SEARCH_TEACHER,
  SEARCH_MODERATOR,
  UPDATE_CLASSROOM,
} from "@/common/apiEndpoints";
import {
  SET_API_SUCCESS,
  SET_OVERLAY_VALUE,
  SET_PARAMS_VALUE,
} from "@/store/mutations";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import {
  getAxiosOptions,
  formatDateTime,
  rightClickHandler,
} from "@/common/utility";
import { GET_TOKEN, GET_PARAMS_VALUE } from "@/store/getters";
import {
  STATUS_PUBLISHED,
  COURSE_TYPE_PRIVATE,
  grades,
} from "@/common/constants";
import ContextMenu from "./ContextMenu.vue";
import CustomDataTable from "./CustomDataTable.vue";
import TeacherAvailabilityCalender from "./TeacherAvailabilityCalender.vue";
import AssignModeratorDailog from "./dialogComponents/AssignModeratorDailog.vue";
import ExtraClassCreateDailog from "./dialogComponents/ExtraClassCreateDailog.vue";
import StudentEnrollmentDialog from "./dialogComponents/StudentEnrollmentDialog.vue";
import TeacherEnrollmentDialog from "./dialogComponents/TeacherEnrollmentDialog.vue";
import {
  classRoomHeaders,
  studentHeadersForEnroll,
  teacherAssignmentHeaders,
} from "@/common/tableHeadersData";
export default {
  data() {
    return {
      instituteId: "",
      instituteName: "",
      contextMenuObject: {},
      addClassRoomDialog: false,
      enrollModeratorDialog: false,
      startDateMenu: false,
      classRoomDialogTitle: "New Classroom",
      editedIndex: -1,
      classRooms: [],
      panel: [],
      studentNames: [],
      classLink: "",
      studentHeadersForEnroll: studentHeadersForEnroll,
      classRoomHeaders: classRoomHeaders,
      editedClassRoom: {
        courseId: "",
      },
      defaultItem: {},
      courses: [],
      notBuyableCourses: [],
      createClassRoomValidation: {
        valid: false,
        nameRules: [(v) => !!v || "This is required"],
      },
      STATUS_PUBLISHED: STATUS_PUBLISHED,
      COURSE_TYPE_PRIVATE: COURSE_TYPE_PRIVATE,
    };
  },
  mounted: function () {
    this.instituteId = this.paramsValue.instituteId;
    this.instituteName = this.paramsValue.instituteName;
    this.getAllCourses();
    this.getAllClassRoomByInstituteId();
  },

  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
      paramsValue: `schoolModule/${GET_PARAMS_VALUE}`,
    }),
  },
  components: {
    ContextMenu,
    CustomDataTable,
    TeacherAvailabilityCalender,
    AssignModeratorDailog,
    ExtraClassCreateDailog,
    StudentEnrollmentDialog,
    TeacherEnrollmentDialog,
  },
  methods: {
    rightClickHandler(e, item) {
      e.preventDefault();
      let textInCell = e.target.textContent;
      if (!textInCell) return;
      if (textInCell.slice(-3) === "...") {
        let curText = textInCell.slice(0, -3);
        let itemData = Object.entries(item.item);
        let findSameText = itemData.find((el) => {
          return el[1]?.toString().includes(curText);
        });
        if (findSameText) {
          this.contextMenuObject = rightClickHandler(
            findSameText[1],
            e.clientX,
            e.clientY
          );
          return;
        }
      }
      this.contextMenuObject = rightClickHandler(
        textInCell,
        e.clientX,
        e.clientY
      );
    },
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
      setParams: `schoolModule/${SET_PARAMS_VALUE}`,
    }),
    isURL(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    openCreateClassroom() {
      this.$router.push({
        name: "CreateClassroom",
      });
    },
    getModelColor(model) {
      if (model == "FRANCHISE") {
        return "orange-chip";
      } else if (model == "NON_FRANCHISE") {
        return "secondary-chip";
      } else {
        return "success-chip";
      }
    },
    viewSchedule(item) {
      var classroomParams = {};
      classroomParams.instituteId = this.instituteId;
      classroomParams.instituteName = this.instituteName;
      classroomParams.classRoomId = item.classRoomId;
      classroomParams.model = item.model;
      classroomParams.className = item.name;
      this.setParams(classroomParams);
      this.$router.push({
        name: "ClassSchedule",
      });
    },
    getAllClassRoomByInstituteId() {
      let url = GET_ALL_CLASSROOMS;
      this.setOverlayValue(true);
      let payload = {};
      payload.instituteId = this.instituteId;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.classRooms = res.data.classrooms;
          this.setOverlayValue(false);
        })
        .catch((error) => {
          error = error.errorMessage;
          this.setOverlayValue(false);
        });
    },
    getAllCourses() {
      let url = GET_ALL_COURSES;
      this.setOverlayValue(true);
      url = url + "?status=" + this.STATUS_PUBLISHED;
      url = url + "&courseType=" + this.COURSE_TYPE_PRIVATE;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.courses = res.data.courses;
          this.notBuyableCourses = this.courses.filter(
            (course) => course.buyable == false || course.buyable == null
          );
          this.setOverlayValue(false);
        })
        .catch((error) => {
          error = error.errorMessage;
          this.setOverlayValue(false);
        });
    },
    formatDateTime(date) {
      return formatDateTime(date);
    },
    openAddClassRoomDialog(classRoom) {
      this.addClassRoomDialog = true;
      this.studentNames = [];
      if (classRoom) {
        this.editedIndex = 0;
        this.editedClassRoom = Object.assign({}, classRoom);
        this.editedClassRoom.startDate =
          this.editedClassRoom.startDate.substring(0, 10);
        this.classRoomDialogTitle = "Classroom Details";
      }
    },
    closeAddClassRoomDialog() {
      this.addClassRoomDialog = false;
      this.selectedTeacher = [];
      this.selectedStudents = [];
      this.editedClassRoom = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.classRoomDialogTitle = "New Classroom";
    },
    openExtraClassDialog(item) {
      this.$refs.extraClassDialog.openExtraClassDialog(item);
    },
    saveClassRoom() {
      if (this.createClassRoomValidation.valid) {
        const payload = {};
        let url = "";
        payload.name = this.editedClassRoom.name.trim();
        payload.courseId = this.editedClassRoom.courseId;
        if (this.editedIndex > -1) {
          payload.classRoomId = this.editedClassRoom.classRoomId;
          url = UPDATE_CLASSROOM;
        } else {
          payload.instituteId = this.instituteId;
          payload.batchNo = this.batchNo;
          payload.teacherId = this.editedClassRoom.teacherId;
          payload.students = this.editedClassRoom.students;
          let startDate = new Date(this.editedClassRoom.startDate);
          payload.startDate = startDate.toISOString();
          url = CREATE_CLASSROOM;
        }
        this.setOverlayValue(true);
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.createClassRoomValidation.valid = false;
            this.editedClassRoom = res.data;
            this.setOverlayValue(false);
            if (this.editedIndex > -1) {
              this.updateClassRoomData(this.editedClassRoom);
              this.setApiSuccess("Classroom updated successfully");
            } else {
              this.setApiSuccess("Classroom created successfully");
              this.getAllClassRoomByInstituteId();
            }
            this.closeAddClassRoomDialog();
          })
          .catch((error) => {
            error = error.errorMessage;
            this.setOverlayValue(false);
            this.closeAddClassRoomDialog();
          });
      }
    },
    closeEnrollDialog() {
      this.selectedModerator = [];
      this.enrollModeratorDialog = false;
      this.moderators = [];
    },
    onTeacherSelected(teacher) {
      this.editedClassRoom = Object.assign(this.editedClassRoom, teacher);
    },
    openModeratorEnrollDialog(item) {
      this.editedClassRoom.classRoomId = item.classRoomId;
      this.editedClassRoom.courseId = item.courseId;
      this.enrollModeratorDialog = true;
    },
    openEnrollDialog(item, assigneeType) {
      if (assigneeType === "Student") {
        var oneToOneClass = item.oneToOne;
        this.$refs.studentEnrollmentDialog.openEnrollDialog(
          item,
          oneToOneClass
        );
      } else if (assigneeType === "Teacher") {
        this.$refs.teacherEnrollmentDialog.openEnrollDialog(item);
      }
      this.editedClassRoom.classRoomId = item.classRoomId;
      this.editedClassRoom.teacherId = item.teacherId;
      this.editedClassRoom.courseId = item.courseId;
      this.panel = [0];
    },

    searchModerators() {
      const payload = {};
      let flag = false;
      if (this.moderatorFilter.mobileNo) {
        payload.mobileNo = this.moderatorFilter.mobileNo.trim();
        flag = true;
      }
      if (this.moderatorFilter.email) {
        payload.emailId = this.moderatorFilter.email.trim();
        flag = true;
      }
      if (this.moderatorFilter.firstName) {
        payload.firstName = this.moderatorFilter.firstName.trim();
        flag = true;
      }
      if (this.moderatorFilter.lastName) {
        payload.lastName = this.moderatorFilter.lastName.trim();
        flag = true;
      }
      let url = SEARCH_MODERATOR;
      if (flag) {
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.moderators = res.data.moderators;
            const self = this;
            self.disabledCount = 0;
            this.moderators.map((item) => {
              if (item.status != "ACTIVE") {
                self.disabledCount += 1;
              }
            });
            this.panel = [];
          })
          .catch((error) => {
            error = error.errorMessage;
          });
      } else {
        this.panel = [];
      }
    },
    openCloseSearchPanel() {
      this.panel.length == 0 ? (this.panel = [0]) : (this.panel = []);
    },
    getCourseNameById(courseId) {
      let c = this.courses.filter((course) => {
        return course.courseId == courseId;
      });
      if (c.length && c[0].name) return c[0].name;
      return "No Course";
    },

    onAssignModerator(moderator) {
      let payload = {};
      payload.classRoomId = this.editedClassRoom.classRoomId;
      let url = CLASSROOM_ASSIGN_MODERATOR;
      payload.moderatorId = moderator.userId;
      this.setOverlayValue(true);
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.updateClassRoomData(res.data);
          this.enrollModeratorDialog = false;
          this.setOverlayValue(false);
          this.setApiSuccess("Moderator Assigned Successfully");
        })
        .catch((error) => {
          error = error.errorMessage;
          this.enrollModeratorDialog = false;
          this.setOverlayValue(false);
        });
    },
    enrollModerator() {
      let payload = {};
      payload.classRoomId = this.editedClassRoom.classRoomId;
      let url = CLASSROOM_ASSIGN_MODERATOR;
      payload.moderatorId = this.selectedModerator[0].userId;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.updateClassRoomData(res.data);
          this.closeEnrollDialog();
          this.setOverlayValue(false);
          this.setApiSuccess("Moderator Assigned Successfully");
        })
        .catch((error) => {
          error = error.errorMessage;
          this.closeEnrollDialog();
          this.setOverlayValue(false);
        });
    },
    unassignModerator(item) {
      let payload = {};
      payload.classRoomId = item.classRoomId;
      let url = CLASSROOM_UN_ASSIGN_MODERATOR;
      payload.moderatorId = item.moderatorInfo.moderatorId;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.updateClassRoomData(res.data);
          this.closeEnrollDialog();
          this.setOverlayValue(false);
          this.getAllClassRoomByInstituteId();
          this.setApiSuccess("Moderator unassigned Successfully");
        })
        .catch((error) => {
          error = error.errorMessage;
          this.closeEnrollDialog();
          this.setOverlayValue(false);
        });
    },
    CloseCreateClassSchedule() {
      this.createScheduleDialog = false;
      this.editedClassRoom = Object.assign({}, this.defaultItem);
    },
    updateClassRoomData(classRoom) {
      var foundIndex = this.classRooms.findIndex(
        (cls) => cls.classRoomId == classRoom.classRoomId
      );
      this.classRooms[foundIndex] = Object.assign(
        this.classRooms[foundIndex],
        classRoom
      );
    },
  },
};
</script>
